import { useLocation } from 'react-router-dom';
import { paths } from 'src/routes/paths';

// @mui
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
// routes
import { RouterLink } from 'src/routes/components';
// theme
import { bgBlur, bgGradient } from 'src/theme/css';
// assets
import logo from 'src/assets/logos/my fvsd logo icon.png';
import Iconify from 'src/components/iconify';
import { PublicClientApplication } from '@azure/msal-browser';

// ----------------------------------------------------------------------
const msalConfig = {
  auth: {
    clientId: '88b6bf8b-3a50-4e61-adc6-6edfbd904c6d',
    redirectUri: paths.auth.jwt.login,
    authority: 'https://login.microsoftonline.com/42242eff-faf6-4ccd-aea3-e2c4479f8ccb',
    navigateToLoginRequestUrl: false,
  },
};

export default function LandingView() {
  const location = useLocation();

  const msalInstance = new PublicClientApplication(msalConfig);

  msalInstance.handleRedirectPromise();

  const loginWithMicrosoft = async () => {
    try {
      const loginRequest = {
        scopes: ['user.read', 'email', 'openid', 'profile', 'Group.Read.All'],
      };
      const loginResponse = await msalInstance.loginRedirect(loginRequest);
    } catch (error) {
      console.error('Login Error', error);
    }
  };

  return (
    <Stack
      sx={{
        pt: 12,
        pb: 4,
        mx: 2,
        minHeight: '100vh',
        textAlign: 'center',
        justifyContent: 'center',
      }}
      spacing={5}
    >
      <Stack justifyContent="center" alignItems="center" width="100%">
        <Box
          component="img"
          alt="auth"
          src={logo}
          sx={{ maxWidth: 400, px: 10, width: '100%', height: 'auto', mb: 5 }}
        />
        <Typography variant="h1" color="grey">
          Welcome To
        </Typography>
        <Typography variant="h1" paragraph>
          MyFVSD
        </Typography>
        <Typography sx={{ color: 'text.secondary', fontSize: 20, my: 5 }}>
          Login below to access your account.
        </Typography>
      </Stack>

      <Stack
        sx={{
          flexGrow: {
            xs: 1,
            sm: 0,
          },
        }}
      />
      <Stack justifyContent="center" width="100%" spacing={8} sx={{ mb: 2 }}>
        <Stack direction="column">
          <Typography variant="body1" padding={2} sx={{ color: 'text.secondary' }}>
            To complete your <b>2025-2026</b> student profile review, login below:
          </Typography>
          <Button
            component={RouterLink}
            href="/login"
            size="large"
            variant="contained"
            color="primary"
            endIcon={<Iconify icon="mdi:login" color="primary" fontSize="1.5rem" />}
            sx={{ width: { sm: 'auto', xs: '100%' }, alignSelf: 'center' }}
          >
            Parent/Guardian Login
          </Button>
        </Stack>
        {/* <Divider sx={{ my: 4, width: '100%' }} /> */}
        <Stack
          direction="column"
          justifyContent="center"
          spacing={2}
          width="100%"
          sx={{ backgroundColor: 'background.neutral', p: 6, borderRadius: 1 }}
        >
          <Typography variant="subtitle1" sx={{ color: 'text.secondary' }}>
            New to FVSD? Enroll your student today!
          </Typography>
          <Button
            component={RouterLink}
            href="/enroll"
            size="large"
            variant="outlined"
            color="primary"
            startIcon={<Iconify icon="mdi:account-plus" color="primary" fontSize="1.5rem" />}
            sx={{ width: 'auto', alignSelf: 'center' }}
          >
            Enroll A New Student
          </Button>
        </Stack>
        <Stack direction="row" justifyContent="center" spacing={2} width="100%">
          <Button
            onClick={loginWithMicrosoft}
            size="large"
            variant="outlined"
            startIcon={<Iconify icon="mdi:account-cog" color="primary" fontSize="1.5rem" />}
            sx={{ width: 'auto', alignSelf: 'center' }}
          >
            MyFVSD Staff Login
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
}
